import { InferGetServerSidePropsType, NextPage } from 'next'

import { useApiData } from '@hozana/api/hooks/useApiData'
import { createGetServerSideData, createGetServerSideProps } from '@hozana/api/server/serverSide'
import { useSelector } from '@hozana/redux/hooks'
import { useRouter } from '@hozana/router'
import { getFirstQueryValue } from '@hozana/router/functions'

import { NAMESPACE } from 'i18n/constants'
import { PAGE } from 'routes/pages'

import { getPrayerEventQuery } from 'modules/event/queries'
import { selectPrayerEvent } from 'modules/event/selectors'

import { PrayerMeetingUpsert } from '../components/PrayerMeetingUpsert/PrayerMeetingUpsert'

export const getServerSideProps = createGetServerSideProps(
  PAGE.MEETING_CREATE,
  ({ params, store }) => [
    'meeting:meeting.organize.title',
    { title: selectPrayerEvent(store.getState(), Number(params.prayerEventId))?.title },
  ],
  createGetServerSideData(({ params }) => ({
    prayerEvent: {
      query: getPrayerEventQuery({ prayerEventId: Number(params.prayerEventId) }),
      displayErrors: true,
    },
  })),
  { namespaces: [NAMESPACE.MEETING] },
)

export type TPrayerMeetingCreatePageProps = InferGetServerSidePropsType<typeof getServerSideProps>

export const PrayerMeetingCreatePage: NextPage<TPrayerMeetingCreatePageProps> = () => {
  const { query } = useRouter()
  const prayerEventId = parseInt(getFirstQueryValue(query.prayerEventId))
  useApiData(
    () => ({
      query: getPrayerEventQuery({ prayerEventId }),
    }),
    [prayerEventId],
  )

  const prayerEvent = useSelector((state) => selectPrayerEvent(state, prayerEventId))

  return <PrayerMeetingUpsert prayerEvent={prayerEvent} />
}
